<template>
    <v-flex class="release-notes mt-5">
        <v-layout row wrap>
            <v-flex
                xs12
                md6
                pr-4
                class="release-notes__blocks inner-scrollbar">
                <h3>
                    <i v-if="canEdit" @click="editRecentReleased()" class="fas fa-pencil-alt pointer" data-qe-id="edit_recent_release"></i>
                    {{ReleaseNotesConstants.RECENTLY_RELEASED}}
                </h3>
                <v-flex v-if="!isEditRecentReleased" class="release-notes__text" :class="canEdit ? 'admin' : '' ">
                    <p v-html="releaseNotes.recentReleased" data-qe-id="recent_release_content"></p>
                </v-flex>
                <v-flex v-else class="ck-editor__block">
                    <ck-editor
                        editor-id="recentReleased_editor"
                        :editor-type="ckEditorType.FULL"
                        data-qe-id="recentReleased_editor"
                        v-model="releaseNotes.recentReleased"
                        class="ck-editor__font">
                    </ck-editor>
                    <v-flex class="ck-editor__block__btns">
                        <v-btn @click="cancelRecentReleased()" class="primary_btn transparent small" data-qe-id="recentReleased_cancel_btn">{{MakeConnectForYouConstants.CANCEL}}</v-btn>
                        <v-btn
                            class="primary_btn small"
                            data-qe-id="recentReleased_save_btn"
                            @click="saveRecentRelease()"
                            :loading="isRecentReleaseSaving"
                            :disabled="validateEditorData(releaseNotes.recentReleased)">
                            {{MakeConnectForYouConstants.SAVE}}
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex
                xs12
                md6
                pl-4
                class="release-notes__blocks inner-scrollbar">
                <h3>
                    <i v-if="canEdit" @click="editComingSoon()" class="fas fa-pencil-alt pointer" data-qe-id="edit_coming_soon"></i>
                    {{ReleaseNotesConstants.COMING_SOON}}
                </h3>
                <v-flex v-if="!isEditComingSoon" class="release-notes__text" :class="canEdit ? 'admin' : '' ">
                    <p v-html="releaseNotes.comingSoon" data-qe-id="coming_soon_content"></p>
                </v-flex>
                <v-flex v-else class="ck-editor__block">
                    <ck-editor
                        editor-id="comingSoon_editor"
                        :editor-type="ckEditorType.FULL"
                        data-qe-id="comingSoon_editor"
                        v-model="releaseNotes.comingSoon"
                        class="ck-editor__font">
                    </ck-editor>
                    <v-flex class="ck-editor__block__btns">
                        <v-btn @click="cancelComingSoon()" class="primary_btn transparent small" data-qe-id="comingSoon_cancel_btn">{{MakeConnectForYouConstants.CANCEL}}</v-btn>
                        <v-btn
                            class="primary_btn small"
                            data-qe-id="comingSoon_save_btn"
                            @click="saveComingSoon()"
                            :loading="isComingSoonSaving"
                            :disabled="validateEditorData(releaseNotes.comingSoon)">
                            {{MakeConnectForYouConstants.SAVE}}
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import { ReleaseNotesConstants, MakeConnectForYouConstants } from "../AssistPage/AssistPageConstants";
    import { mapGetters, mapActions } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import ckEditor from "../CkEditor/CkEditor";
    import { ckEditorType } from "../../plugins/CkEditor/ckEditorTypes.config";

    export default {
        name: 'ReleaseNotesView',

        components: {
            ckEditor,
        },
        created() {
            this.getReleaseNotes();
        },
        data: () => ({
            ReleaseNotesConstants,
            ckEditorType,
            MakeConnectForYouConstants,
            isRecentReleaseSaving: false,
            isComingSoonSaving: false,
            isEditRecentReleased: false,
            isEditComingSoon: false,
            tempRecentReleased: '',
            tempComingSoon: '',

        }),
        computed: {
            ...mapGetters({
                releaseNotes: `assistPage/${storeGetters.releaseNotes}`,
                canEdit: `assistPage/${storeGetters.canEditAssistPage}`,
            }),
        },
        methods: {
            ...mapActions({
                getReleaseNotes: `assistPage/${storeAction.getReleaseNotes}`,
                updateReleaseNotes: `assistPage/${storeAction.updateReleaseNotes}`,
            }),
            saveRecentRelease() {
                this.isRecentReleaseSaving = true;
                this.updateReleaseNotes(this.releaseNotes).then(() => {
                    this.isRecentReleaseSaving = false;
                    this.isEditRecentReleased = false;
                });
            },
            saveComingSoon() {
                this.isComingSoonSaving = true;
                this.updateReleaseNotes(this.releaseNotes).then(() => {
                    this.isComingSoonSaving = false;
                    this.isEditComingSoon = false;
                });
            },
            validateEditorData(body) {
                const div = document.createElement('div');
                div.innerHTML = body;
                const bodyText = div.innerText;
                return bodyText.replace('&nbsp;', '').trim().length < 1;
            },
            editRecentReleased() {
                this.isEditRecentReleased = true;
                this.tempRecentReleased = this.releaseNotes.recentReleased;
            },
            editComingSoon() {
                this.isEditComingSoon = true;
                this.tempComingSoon = this.releaseNotes.comingSoon;
            },
            cancelRecentReleased() {
                this.isEditRecentReleased = false;
                this.releaseNotes.recentReleased = this.tempRecentReleased;
            },
            cancelComingSoon() {
                this.isEditComingSoon = false;
                this.releaseNotes.comingSoon = this.tempComingSoon;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .release-notes {
        &__blocks {
            overflow: auto;
            margin-right: 0px !important;
            margin-bottom: 50px;
        }
        .ck-editor__block {
            border: 1px solid $ypo-title-border;
            border-radius: 3px;
            margin: 0 30px;

            .ck-editor .cke_top {
                border-top: none;
                background: rgba($ypo-title-border, 0.15);
            }

            .cke_contents {
                padding: 0 10px;

                iframe {
                    height: calc(100% - 10px) !important;
                }
            }

            &__btns {
                text-align: right;
                padding: 5px 1px;
                border-top: 1px solid rgba($ypo-title-border, 0.5);
                ;
            }
        }

        &__text {
            margin-left: 30px;
            word-break: break-word;

            &.admin {
                margin-left: 52px;
            }
        }

        @include breakpoint(sm) {
            &__blocks {
                padding: 0 0 10px 0 !important;
            }
        }

        @include breakpoint(xs) {
            padding: 0px 15px;

            h3 {
                padding: 0px !important;
            }

            &__text {
                margin-left: 0px;

                &.admin {
                    margin-left: 20px;
                }
            }
            .ck-editor__block { 
                margin: 0 5px;
                .cke_contents {
                    overflow-x: auto;
                }
            }
        }
    }
</style>
